<template>
  <v-autocomplete
    color="primary"
    v-model="stockPositionSelected"
    :clearable="!unclearable"
    :items="stockPositionItems"
    :loading="stockPositionLoading"
    :search-input.sync="stockPositionSearch"
    item-value="id"
    item-text="Description"
    item-disabled="disabled"
    :label="noLabel ? '' : label ? label : $t('Position.ObjectName')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
  >
  </v-autocomplete>
</template>

<script>
import i18n from "@/i18n";
import StockPosition from "@/api/stock_position";
import Stocks from "@/api/stocks";

export default {
  name: "SearcherStockPosition",

  props: {
    value: Object,
    stockId: Number,
    existMaterial: Number, //盘点筛选新商品
    dense: Boolean,
    status: Number,
    noLabel: Boolean,
    label: String,
    unclearable: Boolean,
    disabledItems: Array,
    stockAreaSetting: Boolean, //库区是否启用
    stockAreaId: Number, //库区id
    defaultId: Number, // 默认选中ID
  },

  computed: {
    stockPositionItems() {
      return this.stockPosition.map((position) => {
        var Description = i18n.t("MovePositionOrder.DetailFields.position", [
          position.position_code,
          position.position_name,
        ]);
        if (this.stock && this.stock.position_name_display) {
          if (this.stock.position_name_display.indexOf(2) > -1) {
            Description = position.position_name;
          }
          if (
            this.stock.position_name_display.indexOf(4) > -1 &&
            position.stock_roadway
          ) {
            Description = position.stock_roadway.code + " - " + Description;
          }
          if (
            this.stock.position_name_display.indexOf(3) > -1 &&
            position.stock_area
          ) {
            Description = position.stock_area.area_name + " - " + Description;
          }
        }
        if (position.stock_position_label) {
          Description =
            Description +
            "（" +
            position.stock_position_label.label_name +
            "）";
        }

        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.position_id == position.id
            )
          : false;
        return Object.assign({}, position, { Description, disabled });
      });
    },
  },

  data: () => ({
    stock: null,
    stockPosition: [],
    stockPositionLoading: false,
    stockPositionSearch: "",
    stockPositionSelected: [],
  }),

  mounted() {
    this.getStockPositionsFromAPI();
  },

  methods: {
    getStockPositionsFromAPI() {
      this.stockPositionLoading = true;
      var options = {
        stock_id: this.stockId,
        status: this.status,
        exist_material: this.existMaterial,
      };
      if (this.stockAreaSetting) {
        if (this.stockAreaId < 0 && options.stock_area_id) {
          delete options.stock_area_id;
        } else if (this.stockAreaId >= 0) {
          Object.assign(options, {
            stock_area_id: this.stockAreaId,
          });
        }
      }

      if (this.stockId) {
        //获取仓库信息
        Stocks.fetchOne(this.stockId).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.stock = response.data.stock;
            }
          }.bind(this)
        );
        //获取库位列表
        StockPosition.fetchAllForSelect(options)
          .then(
            function (response) {
              if (response.data.status.isOK()) {
                this.stockPosition = response.data.stock_positions;
                if (this.defaultId) {
                  let res = this.stockPosition.filter((v) => {
                    return v.id == this.defaultId;
                  });
                  this.stockPositionSelected = res[0];
                }
                this.stockPosition.unshift({
                  id: 0,
                  position_name: i18n.t("StockArea.noStockPosition"),
                });
              }
              this.stockPositionLoading = false;
            }.bind(this)
          )
          .catch(
            function () {
              this.stockPositionLoading = false;
            }.bind(this)
          );
      }
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.stockPositionSelected = this.value;
      },
    },
    stockAreaSetting: {
      immediate: true,
      handler() {
        this.getStockPositionsFromAPI();
      },
    },
    stockAreaId: {
      deep: true,
      handler() {
        this.getStockPositionsFromAPI();
      },
    },
    stockId: {
      immediate: true,
      handler() {
        this.getStockPositionsFromAPI();
      },
    },
    stockPositionSelected: {
      handler() {
        this.$emit("input", this.stockPositionSelected);
      },
    },
  },
};
</script>